import React, { useContext } from 'react';
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionActions,
    DialogContent,
    Dialog,
    DialogActions,
    DialogTitle,
    Button,
    TextField,
    FormControl,
    Typography,
    Container,
    FormLabel,
} from '@material-ui/core'
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Alert from '@material-ui/lab/Alert';

import { signUpForChallenge } from '../../../actions/challenge-actions';

import ChallengeContext from '../../../context/challenge-context'
import useStyles from '../../../styles/components/rewards/stylesRewardShop';


const SignUpDialog = () => {

    const classes = useStyles();
    const { challengeContext, dispatch } = useContext(ChallengeContext);

    const handleClose = () => {
        setAlert('', 'info');
        challengeContext.dialogs.signUpDialog = false;
        dispatch({ type: 'SET_DIALOGS', dialogs: challengeContext.dialogs });
    }

    const setAlert = (message, severity) => {
        challengeContext.alert.severity = severity;
        challengeContext.alert.message = message;
        dispatch({ type: 'SET_ALERT', alert: challengeContext.alert });
    }

    const handleReLoadContent = () => {
        setAlert('', 'info');
        challengeContext.dialogs.signUpDialog = false;
        dispatch({ type: 'SET_DIALOGS', dialogs: challengeContext.dialogs });
        dispatch({ type: 'SET_RELOADCONTENT', reLoadContent: true });
    }

    const handleOk = async () => {
        if (!checkValidation()) {
            dispatch({ type: 'SET_SIGNUP_LOADING', signUpLoading: true });
            let response = await signUpForChallenge(JSON.stringify(challengeContext.signUpForm));
            dispatch({ type: 'SET_SIGNUP_LOADING', signUpLoading: false });
            if (response.status === "Success") {
                setAlert(response.message, "success");
                challengeContext.signUpResult.isError = false;
                challengeContext.signUpResult.message = response.message;
                dispatch({ type: 'SET_SIGNUPRESULT', signUpResult: challengeContext.signUpResult });
            }
            else {
                setAlert(response.message, "error");
                challengeContext.signUpResult.isError = true;
                dispatch({ type: 'SET_SIGNUPRESULT', signUpResult: challengeContext.signUpResult });

            }
        }
    };

    const checkValidation = () => {
        let isError = false;
        if (challengeContext.signUpForm.teamName.length < 1) {
            setAlert("Team Name can't be empty", 'error');
            return isError = true;
        }

        for (let i = 0; i < challengeContext.signUpForm.teamMembers.length; i++) {
            if (challengeContext.signUpForm.teamMembers[i].studentNumber.length < 1) {
                setAlert("Student Number can't be empty", 'error');
                isError = true;
                break;
            }
        }

        if (!isError) {
            var valueArr = challengeContext.signUpForm.teamMembers.map(function (item) { return item.studentNumber.toLowerCase() });
            let isDuplicate = valueArr.some(function (item, idx) {
                return valueArr.indexOf(item) != idx
            });
            if (isDuplicate) {
                setAlert("Please provide unique student number for each team member.", 'error');
                isError = true;
            }
        }

        return isError;
    }

    const handleChange = (event, label, index) => {
        switch (label) {
            case "teamName":
                challengeContext.signUpForm.teamName = event.target.value;
                dispatch({ type: 'SET_SIGNUPFORM', signUpForm: challengeContext.signUpForm });
                break;
            case "studentNumber":
                challengeContext.signUpForm.teamMembers[index].studentNumber = event.target.value;
                dispatch({ type: 'SET_SIGNUPFORM', signUpForm: challengeContext.signUpForm });
                break;
        }
    }

    const handleAction = (action, index) => {
        switch (action) {
            case "removeMember":
                let members = challengeContext.signUpForm.teamMembers;
                if (members.length > 3) {
                    challengeContext.signUpForm.teamMembers.splice(index, 1);
                    dispatch({ type: 'SET_SIGNUPFORM', signUpForm: challengeContext.signUpForm });
                }
                else {
                    alert("You need at least 3 members");
                }
                break;
            case "addMember":
                members = challengeContext.signUpForm.teamMembers;
                if (members.length > 4) {
                    alert("Maximum team size is 5");
                }
                else {
                    let member = {
                        studentNumber: '',
                        isLeader: false
                    };
                    challengeContext.signUpForm.teamMembers.push(member);
                    dispatch({ type: 'SET_SIGNUPFORM', signUpForm: challengeContext.signUpForm });
                }

                break;
        }
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth='md'
            open={challengeContext.dialogs.signUpDialog}
            classes={{
                root: classes.rootDialogConfirm,
                paper: classes.paperDialogConfirm,
            }}
        >
            <DialogTitle disableTypography={true} style={{ fontSize: '20px' }} classes={{ root: classes.rootDialogConfirmTitle }}>
                Sign Up for Challenge
            </DialogTitle>
            {
                challengeContext.signUpLoading ?
                    <Alert variant="outlined" severity="info" style={{ margin: "10px" }}>Please wait for a while...</Alert>
                    :
                    !challengeContext.signUpResult.isError && challengeContext.signUpResult.message.length > 0 ?
                        <>
                            <DialogContent classes={{ root: classes.rootDialogConfirmContent }}>
                                <Alert style={{ margin: "10px" }} variant="outlined" severity={challengeContext.alert.severity}>{challengeContext.alert.message}</Alert>
                            </DialogContent>
                            <DialogActions classes={{ root: classes.rootDialogActions }}>
                                <Button onClick={handleReLoadContent} className={clsx(classes.buttonDialogConfirm, classes.buttonYes)}>
                                    Ok
                                </Button>
                            </DialogActions>
                        </>
                        :
                        <>
                            <DialogContent classes={{ root: classes.rootDialogConfirmContent }}>
                                <div className={classes.dialogContentNote} style={{ fontSize: '18px' }}>
                                    Note: You can sign up for minimum (3) and maximum (5)  per team.
                                </div>
                                <Accordion defaultExpanded>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-label="Expand"
                                        aria-controls="additional-actions1-content"
                                        id="additional-actions1-header">
                                        <Typography variant="body1">Please provide necessary information</Typography>
                                    </AccordionSummary>
                                    <Container style={{ margin: '5px' }}>

                                        {
                                            challengeContext.alert.severity.length > 0 ?

                                                <Alert variant="outlined" style={{ marginBottom: '20px' }} severity={challengeContext.alert.severity}>{challengeContext.alert.message}</Alert>
                                                : <></>
                                        }

                                        <Grid container alignItems="center" style={{ marginTop: '10px' }}>
                                            <TextField
                                                style={{ width: '300px' }}
                                                color="secondary"
                                                required
                                                label="Team Name"
                                                variant="outlined"
                                                value={challengeContext.signUpForm.teamName}
                                                onChange={event => handleChange(event, 'teamName')}

                                            />

                                        </Grid>
                                        <FormLabel component="legend" style={{ marginTop: '20px' }}>Team Members</FormLabel>

                                        {challengeContext.signUpForm.teamMembers.map((member, index) => (
                                            <Grid key={index} container alignItems="center">
                                                <FormControl style={{ marginRight: '20px', marginTop: '10px' }}>
                                                    <TextField
                                                        disabled={member.isLeader ? true : false}
                                                        color="secondary"
                                                        required
                                                        fullWidth
                                                        label="Student Number"
                                                        variant="outlined"
                                                        value={member.studentNumber}
                                                        onChange={event => handleChange(event, "studentNumber", index)}

                                                    />
                                                </FormControl>
                                                <FormControl style={{ marginTop: '10px' }}>
                                                    {
                                                        member.isLeader ?
                                                            <></>
                                                            :
                                                            <Button
                                                                className={clsx(classes.buttonDialogConfirm, classes.buttonCancle)}
                                                                onClick={() => handleAction('removeMember', index)}>
                                                                Remove
                                            </Button>
                                                    }
                                                </FormControl>
                                            </Grid>
                                        ))}

                                        <AccordionActions>
                                            <Button className={clsx(classes.buttonAddMember, classes.buttonYes)} onClick={() => handleAction('addMember')}>
                                                Add Member
                                            </Button>
                                        </AccordionActions>

                                    </Container>
                                </Accordion>

                            </DialogContent>

                            <DialogActions classes={{ root: classes.rootDialogActions }}>
                                <Button onClick={handleClose} className={clsx(classes.buttonDialogConfirm, classes.buttonCancle)}>
                                    Cancel
                        </Button>
                                <Button onClick={handleOk} className={clsx(classes.buttonDialogConfirm, classes.buttonYes)}>
                                    Sign Up
                        </Button>
                            </DialogActions>
                        </>
            }
        </Dialog>
    );
};

export default SignUpDialog;

//<div className={classes.dialogContentConfirm}>Do you want to send the following reward(s) redemption request?</div>